var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "청약안내",
            "tabActive": "청약일정",
            "bg": "/images/sub/subscription/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("청약안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("청약일정")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--xl",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "md": "4",
      "lg": "auto"
    }
  }, [_c('div', {
    staticClass: "image-wrap image-wrap--sm"
  }, [_c('v-img', {
    attrs: {
      "eager": "",
      "src": "/images/sub/subscription/schedule/schedule.jpg"
    }
  })], 1)]), _c('v-col', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('v-card', {
    staticClass: "schedule-card",
    attrs: {
      "flat": "",
      "tile": "",
      "color": "primary"
    }
  }, [_c('tit-tertiary', [_vm._v("성북 펠릭스 청약 일정 안내")])], 1)], 1)]), _vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      staticClass: "schedule-card",
      class: {
        'schedule-card--last': index === _vm.items.length - 1
      },
      attrs: {
        "flat": "",
        "tile": "",
        "color": "grey lighten-5"
      }
    }, [_c('txt-quarternary', [_c('span', {
      staticClass: "grey--text text--darken-4 mr-10px font-weight-bold"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(_vm._s(item.text))])], 1)], 1)];
  })], 2), _c('txt-primary', {
    staticClass: "mt-12px mt-md-16px"
  }, [_vm._v("※ 준공 및 사업 진행 현황에 따라 달라질 수 있습니다.")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }